export type ChangePasswordFormType = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export type ForgotPasswordFormType = {
  email: string;
  tenant: string;
};

export const CHANGE_PASSWORD_FORM_INITIAL_VALUES: ChangePasswordFormType = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

export const FORGOT_PASSWORD_FORM_INITIAL_VALUES: ForgotPasswordFormType = {
  email: "",
  tenant: "",
};
